import { Link } from "react-router-dom";
import { categories } from "@/mocks/posts";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg">
                <i className="ri-fire-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">吃瓜看料</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80">
              全网热门吃瓜看料聚集地，每日更新娱乐八卦、社会热点、行业秘闻。无论你想看明星动态还是职场爆料，
              这里都是你的吃瓜看料基地，海量内容等你来挖。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-tiktok-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100"
                >
                  <i className={icon} aria-hidden="true"></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-accent-400 mb-4">吃瓜分类</h3>
            <ul className="space-y-2.5 text-sm">
              {categories.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/category/${item.slug}`}
                    className="text-background-200/80 hover:text-background-50 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/rank" className="text-background-200/80 hover:text-background-50 transition-colors">
                  全网热榜
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-accent-400 mb-4">关于本站</h3>
            <ul className="space-y-2.5 text-sm">
              <li className="text-background-200/80">关于我们</li>
              <li className="text-background-200/80">我要爆料</li>
              <li className="text-background-200/80">内容合作</li>
              <li className="text-background-200/80">免责声明</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300/70">
            © 2026 吃瓜看料聚集地 · 本站内容均为示例演示，不构成任何事实陈述
          </p>
          <p className="text-xs text-background-300/70">
            理性吃瓜 · 文明上网 · 拒绝网络暴力
          </p>
        </div>
      </div>
    </footer>
  );
}